type Breakpoint = {
    position: number
    onEnter?: () => void
    onLeave?: () => void
}

const breakpoints: Breakpoint[] = []

let pos = 0

const checkScrollPosition = () => {
    pos = window.scrollY
    breakpoints.forEach((bp) => {
        if (pos >= bp.position) {
            if (bp.onEnter) bp.onEnter()
        } else {
            if (bp.onLeave) bp.onLeave()
        }
    })
}

let ticking = false

window.addEventListener('scroll', () => {
    if (!ticking) {
        setTimeout(() => {
            checkScrollPosition()
            ticking = false
        }, 300)
        ticking = true
    }
})

type ScrollEventOptions = {
    position?: number
    onEnter?: () => void
    onLeave?: () => void
}
export const addScrollEvent = ({ position = 100, onEnter, onLeave }: ScrollEventOptions = {}) => {
    breakpoints.push({ position, onEnter, onLeave })
    if (pos >= position) {
        if (onEnter) onEnter()
    } else {
        if (onLeave) onLeave()
    }
}

window.addEventListener('DOMContentLoaded', () => {
    checkScrollPosition()
})
